import {
  FETCH_VISIT_FAIL,
  FETCH_VISIT_REQUEST,
  FETCH_VISIT_SUCCESS,
} from "../../ActionType/VisitType/VisitType";
// import { CREATE_WHATS_APP_SUCCESS, UPDATE_WHATS_APP_SUCCESS } from "../../ActionType/WhatsAppType/WhatsAppType";
const initalState= {loading: true, visits: [], error: ""}
export const getVisitReducer = (
  state = initalState,
  action
) => {
  switch (action.type) {
    case FETCH_VISIT_REQUEST:
      return {
        loading: true,
        visits: [],
      };
    case FETCH_VISIT_SUCCESS:
      return {
        loading: false,
        visits: action.payload,
        error: "",
      };
    case FETCH_VISIT_FAIL:
      return {
        loading: false,
        visits: [],
        error: "",
      };
  
    default:
      return state;
  }
};
